import styled from 'styled-components';

export const CardsWrapper = styled.div`
  margin: 50px auto 14px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;

  @media ${(props) => props.theme.device.tablet} {
    flex-flow: column;
  }

  > div {
    max-width: 30%;
    @media ${(props) => props.theme.device.tablet} {
      max-width: 100%;
      width: 100%;
      margin-bottom: 57px;
    }
    &:last-child {
      @media ${(props) => props.theme.device.tablet} {
        margin-bottom: 0;
      }
    }
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    margin-top: 18px;
  }
  .step {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 24px;
    color: ${(props) => props.theme.colors.bgSubFooter};
    position: absolute;
    top: -12px;
    left: calc(50% - 40px);
    z-index: 1;
  }
`;

export const Image = styled.img`
  width: 86px;
  height: 86px;
  margin-bottom: 30px;
  position: relative;
`;

export const Arrow = styled.img`
  width: 50%;
  height: auto;
  position: absolute;
  top: 40px;
  right: -33%;

  @media ${(props) => props.theme.device.tabletL} {
    width: 1.5%;
    bottom: calc(-4% - 34px);
    left: calc(50% - 6px);
    top: unset;
    right: unset;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 3%;
    bottom: calc(-4% - 34px);
    left: calc(50% - 6px);
    top: unset;
    right: unset;
  }
`;
